import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { CustomAlert, CustomButton, Text } from '../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';
import { Archive as ArchiveIcon } from '../../../../../shared/Assets/svgIcons';
import { ButtonWrapper } from '../../../../../components/StyledComponents';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { ProgramProperties } from '../../../../../redux/API/ClientAPIHelpers/clientProgramProperties';
import { archiveProgram } from '../../../../../redux/State/clientSlice/clientProgramSlice';
import { useProgramsContext } from '../ProgramsContext';

const ArchiveContent = ({ data, onClose }: { data: ProgramProperties; onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const { fetchData } = useProgramsContext();

	const archiveHandler = () => {
		dispatch(archiveProgram(data))
			.then(unwrapResult)
			.then(() => {
				fetchData();
				onClose();
			})
			.catch(errorNormalizer);
	};

	return (
		<ButtonWrapper isInModal>
			<CustomButton title="Yes" onClick={archiveHandler} />
			<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} />
		</ButtonWrapper>
	);
};

const ArchiveComponent = ({ data, onlyIcon }: { data: ProgramProperties; onlyIcon?: boolean }) => {
	const [open, setOpen] = useState<boolean>(false);
	const closeHandler = () => setOpen(false);
	const isArchiving = useSelector((state) => state.clientProgram.isArchiving);

	return (
		<>
			<div className="actionRow" onClick={() => setOpen(true)}>
				<div className="actionIcon">
					<ArchiveIcon />
				</div>
				{!onlyIcon && (
					<div className="actionContent">
						<Text title="Archive" type="psm" fontWeight="medium" />
					</div>
				)}
			</div>
			<CustomAlert
				isBusy={isArchiving}
				title="Do you want to archive the selected target?"
				open={open}
				onClose={closeHandler}
				Content={({ onClose }) => <ArchiveContent data={data} onClose={onClose} />}
			/>
		</>
	);
};

export default ArchiveComponent;
